import { createContext, useContext } from 'react';

import { SettingsType, useProvideSettings } from './use-settings';

const SettingsContext = createContext(
  {} as {
    setSettings: (payload: SettingsType) => void;
    settings: SettingsType;
  },
);

export function ProvideSettings({ children }: { children: React.ReactNode }) {
  const { settings, defaultSettings, setSettings } = useProvideSettings();

  return (
    <SettingsContext.Provider
      value={{ settings: { ...defaultSettings, ...settings }, setSettings }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

// hook for child components to get the auth object and re-render when it changes
export const useSettings = () => {
  return useContext(SettingsContext);
};
